import Vue from 'vue'
import { paramCase } from 'change-case'

export default function install (vue, options) {
  const whitelabel = new Vue({
    data: {
      colors: {},
      strings: {},
      urls: {},
      images: {},
      loaded: false
    },
    created: async function () {
      this.load()
    },
    methods: {
      load: async function () {
        const config = this.getLocalConfig() || await this.getOnlineConfig()
        this.setConfig(config)
        this.loaded = true
      },
      getLocalConfig: function () {
        if (options.cache) {
          const config = sessionStorage.getItem('whitelabel')
          if (config) {
            return JSON.parse(config)
          }
          return null
        }
      },
      getOnlineConfig: async function () {
        const response = await fetch(`${process.env.VUE_APP_WHITELABEL_API}/getConfig?project=${options.project}`)
        if (response.status === 200) {
          const config = await response.json()
          return config
        }
        return null
      },
      setConfig: function (config) {
        Object.keys(config).forEach(key => {
          this[key] = config[key]
        })
        if (options.cache) sessionStorage.setItem('whitelabel', JSON.stringify(config))
        if (options.cssVariables) this.setCSSVariables(config)
      },
      setCSSVariables: function (config) {
        const { colors } = config
        const set = (key, value) => {
          document.documentElement.style.setProperty(`--${paramCase(key)}`, value)
        }
        Object.keys(colors).forEach(key => {
          if (key === 'on') {
            Object.keys(colors.on).forEach(key2 => set(`on-${key2}`, colors.on[key2]))
          } else {
            set(key, colors[key])
          }
        })
      }
    }
  })
  vue.prototype.$wl = whitelabel
  vue.mixin({
    data: () => ({
      wl: whitelabel
    })
  })
}
